module.exports = __webpack_public_path__ + "media/question6_au.8a07e0c6.mp3";